import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importManufacturerApi = createApi({
  reducerPath: "importManufacturer",
  baseQuery,
  tagTypes: ["importManufacturer"],
  endpoints: (builder) => ({
    createManufacture: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `import/product/manufacturerDetails/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { manufacturer: data },
      }),
      invalidatesTags: ["importManufacturer"],
    }),

    updateManufacture: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `import/product/manufacturerDetails/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { manufacturer: data },
      }),
      invalidatesTags: ["importManufacturer"],
    }),

    getManufactureId: builder.query({
      query: ({ id }) => `/import/product/manufacturerDetails/${id}`,
      transformResponse: (response) => response?.data,
      providesTags: ["importManufacturer"],
    }),
  }),
});

export const {
  useCreateManufactureMutation,
  useUpdateManufactureMutation,
  useLazyGetManufactureIdQuery,
} = importManufacturerApi;
